export default "__VITE_ASSET__o$1AEFal__"